import React from 'react';

import Select from 'src/components/input/select/Select';
import { type LeadsGrouping, leadsGroupingOptions } from 'src/pages/landlord/leads/types';
import { useLeadsPageContext } from 'src/pages/landlord/leads/provider';
import { analyticsClient } from 'src/services/analytics';
import { AnalyticsEvent } from 'src/services/analytics/events';

const SelectGroupBy: React.FC = () => {
    const { grouping, setGrouping } = useLeadsPageContext();

    const handleChange = (value: LeadsGrouping) => {
        setGrouping(value);
        analyticsClient.track(AnalyticsEvent.LEADS_GROUP_BY_SELECTED, { grouping: value ?? 'None' });
    };

    return (
        <Select
            label="Group by"
            emptyText="None"
            options={leadsGroupingOptions}
            value={grouping as string}
            onChange={(value) => handleChange(value as LeadsGrouping)}
            isClearable
            clearableText="None"
            size="small"
            fullWidth
            sx={{ bgcolor: 'white' }}
            data-testid="leads-group-by-select"
        />
    );
};

export default SelectGroupBy;